<template>
  <div class="report">
    <div class="report_title">{{ $t('home.report.title') }}</div>
    <div class="report_cont">
      <div class="report_li" v-for="(el, index) in reportData" @click="linkhref(el.link)">
        <img class="li_img" v-lazy="el.img" alt="">
        <div class="li_content">
          <div class="title">{{ el.name }}</div>
          <div class="text1">{{ el.subjection }}</div>
          <div class="text2"><p>{{ el.data }}</p></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  // @ is an alias to /src
  import { defineComponent, ref, onMounted ,computed } from "vue";
  import { useI18n } from "vue-i18n";
  import { useStore } from "vuex"
  import media_img22 from "@/assets/media/media_img22.jpg"
  import media_img21 from "@/assets/media/media_img21.avif"
  import media_img20 from "@/assets/media/media_img20.webp"
  import media_img19 from "@/assets/media/media_img19.jpg"
  import media_img18 from "@/assets/media/media_img18.png"
  import media_img17 from "@/assets/media/media_img17.png"
  import media_img16 from "@/assets/media/media_img16.jpg"
  import media_img15 from "@/assets/media/media_img15.jpg"
  import media_img14 from "@/assets/media/media_img14.webp"
  import media_img13 from "@/assets/media/media_img13.png"
  import media_img12 from "@/assets/media/media_img12.png"
  import media_img11 from "@/assets/media/media_img11.avif"
  import media_img10 from "@/assets/media/media_img10.avif"
  import media_img9 from "@/assets/media/media_img9.webp"
  import media_img8 from "@/assets/media/media_img8.png"
  import media_img7 from "@/assets/media/media_img7.jpg"
  import media_img6 from "@/assets/media/media_img6.jpg"
  import media_img5 from "@/assets/media/media_img5.avif"
  import media_img4 from "@/assets/media/media_img4.png"
  import media_img_default1 from "@/assets/media/media_img_default1.png"
  import media_img_default2 from "@/assets/media/media_img_default2.png"
  import media_img2 from "@/assets/media/media_img2.webp"
  import media_img1 from "@/assets/media/media_img1.webp"
  export default defineComponent({
    name: 'report',
    setup() {
      const { t, locale } = useI18n()
      const store = useStore()
      let lan = computed(() => store.state.lan)
      const reportData = ref([
        {
          name: '解读 DeepLink Protocol：利用分布式算力，打造下一代云游戏平台',
          link: 'https://techub.news/newDetails/?id=ff04e75f52244341a69848148e45be22',
          data: '2024.09.10',
          subjection: 'Techub News',
          img: media_img22
        },
        {
          name: 'DeepLink Protocol’s Strategic Vision: Redefining the Future of Cloud Gaming',
          link: 'https://news.bitcoin.com/deeplink-protocols-strategic-vision-redefining-the-future-of-cloud-gaming/',
          data: '2024.08.27',
          subjection: 'Bitcoin.comNews',
          img: media_img20
        },
        {
          name: '专访DeepLink Protocol CEO：去中心化云游戏能让人人都玩上极致的《黑神话：悟空》吗？',
          link: 'https://www.panewslab.com/zh/articledetails/c8sd2cu7.html',
          data: '2024.08.27',
          subjection: 'PANews',
          img: media_img19
        },
        {
          name: 'Cloud gaming powered by AI and blockchain: Interview with DeepLink',
          link: 'https://cointelegraph.com/news/cloud-gaming-powered-by-ai-and-blockchain-interview-with-deeplink',
          data: '2024.08.22',
          subjection: 'cointelegraph',
          img: media_img21
        },
        {
          name: '专访DeepLink Protocol CEO：DePIN变革云游戏市场',
          link: 'https://www.odaily.news/post/5197636',
          data: '2024-08-14',
          subjection: 'odaily',
          img: media_img16
        },
        {
          name: 'DeepLink Protocol: Exploring Innovations in Cloud Gaming and Cryptocurrency Mining',
          link: 'https://bitcoinist.com/deeplink-protocol-exploring-innovations-in-cloud-gaming-and-cryptocurrency-mining/',
          data: '24-08-12 21:36',
          subjection: 'Bitcoinist',
          img: media_img13
        },
        {
          name: '딥링크, GC Capital로부터 투자 유치···M3 DAO와 전략적 협력도 체결',
          link: 'https://n.news.naver.com/mnews/article/030/0003230565?sid=101',
          data: '2024.08.09',
          subjection: 'news',
          img: media_img18
        },
        {
          name: "딥링크, 스탠포드대 '탈중앙화 AI의 미래' 서밋에서 혁신적 비전 제시",
          link: 'https://n.news.naver.com/mnews/article/030/0003230099?sid=101',
          data: '2024.08.08',
          subjection: 'news',
          img: media_img17
        },
        {
          name: 'Family Offices Investors Summit USA Edition Announces Over 1,000 Investors to Attend, Managing $780 Billion',
          link: 'https://finance.yahoo.com/news/family-offices-investors-summit-usa-113600931.html?guccounter=1',
          data: '24-07-25 15:36',
          subjection: 'Yahoo',
          img: media_img14
        },
        {
          name: 'AI×DePINのDeepLink Protcolについて解説！評価額3億ドルの注目プロジェクト！',
          link: 'https://cryptodog.jp/archives/7018',
          data: '24-07-24',
          subjection: 'crypto dog',
          img: media_img13
        },
        {
          name: 'DeepLink Protcolとは？注目のDePIN銘柄のパブリックセールについても',
          link: 'https://cryptocurrency-sat.com/topic/press/what-is-deeplink-protcol-public-sale-of-depin-stocks-in-the-spotlight/',
          data: '24-07-21',
          subjection: 'cryptocurrency',
          img: media_img12
        },
        {
          name: '专访DeepLink Protocol CEO：低成本玩3A大作 AI+DePin+GameFi变革云游戏',
          link: 'https://www.jinse.cn/blockchain/3692049.html?source=m',
          data: '2024/07/19 16:56',
          subjection: 'jinse',
          img: media_img15
        },
        {
          name: 'DeepLinkとは？大手プラットフォームより80％安くクラウドゲームが可能！仮想通貨取引所に上場間近',
          link: 'https://jp.cointelegraph.com/news/deeplink-offers-cloud-games-80-cheaper-than-major-platforms',
          data: '24-07-09 18:00',
          subjection: 'cointelegraph',
          img: media_img11
        },
        {
          name: 'DePIN XがDeepLink Protocolに戦略的投資、評価額２億ドル以上の次世代クラウド・ゲーム・ソリューション、間もなく$DLCのパブリックセールを予定',
          link: 'https://jp.cointelegraph.com/press-releases/depin-x-makes-strategic-investment-in-deeplink-protocol',
          data: '24-05-27 17:25',
          subjection: 'cointelegraph',
          img: media_img10
        },
        {
          name: 'DeepLink与BYBIT合作举办投资者见面会，展示去中心化AI云游戏的未来',
          link: 'https://www.theblockbeats.info/news/53297',
          data: '24-04-26 22:21',
          subjection: 'blockbeats',
          img: media_img9
        },
        {
          name: '딥링크, 바이비트와 공동 투자자 밋업 개최… 탈중앙화 AI 클라우드 게임 미래 제시',
          link: 'https://www.blockchaintoday.co.kr/news/articleView.html?idxno=43023',
          data: '2024.04.26 18:56',
          subjection: 'blockchain',
          img: media_img8
        },
        {
          name: 'DeepLink Protocol团队受邀参加日本东京TEAMZ WEB3/AI SUMMIT',
          link: 'https://www.theblockbeats.info/news/53166',
          data: '2024-04-17 12:02',
          subjection: 'blockbeats',
          img: media_img6
        },
        {
          name: 'DeepLink Protocol Raises $8 Million - A Game Changer in AI+3A Game +GameFi+ DePIN Industry',
          link: 'https://finance.yahoo.com/news/deeplink-protocol-raises-8-million-120000682.html',
          data: 'Mon, Apr 15, 2024, 8:00 PM',
          subjection: 'Yahoo',
          img: media_img7
        },
        {
          name: '딥링크 프로토콜, ‘2024년 제품 개발 로드맵’ 공개',
          link: 'https://naver.me/xRPw8etS',
          data: '2024-04-09 18:21 (화)',
          subjection: 'datanet',
          img: media_img4
        },
        {
          name: 'DeepLink Research Report',
          link: 'https://medium.com/@DeepLinkGlobal/deeplink-research-report-b64c6776c84d',
          data: '2024-04-09 08:40',
          subjection: 'medium',
          img: media_img2
        },
        {
          name: 'AIとゲームの革命：DeepBrain Chainによるブロックチェーンの革新と DeepLink Protocolを通じた日本のゲーム産業の新たな夜明け',
          link: 'https://jp.cointelegraph.com/press-releases/ai-and-the-game-revolution-a-new-dawn-for-the-japanese-game-industry',
          data: '2024年04月05日 / 16:25',
          subjection: 'cointelegraph',
          img: media_img5
        },
        {
          name: 'Decentralized AI Cloud Gaming Protocol DeepLink Raises $8 Million in Angel and Series A Funding Rounds',
          link: 'https://www.binance.com/en/square/post/2024-04-02-decentralized-ai-cloud-gaming-protocol-deeplink-raises-8-million-in-angel-and-series-a-funding-rounds-6220029939497',
          data: 'Apr 2, 2024',
          subjection: 'Binance',
          img: media_img_default1
        },
        {
          name: '去中心化AI云游戏协议DeepLink Protocol完成超800万美元融资，ROCK Ventures等参投',
          link: 'https://www.theblockbeats.info/flash/242999',
          data: '2024-04-02 15:00',
          subjection: 'blockbeats',
          img: media_img_default2
        },
        {
          name: 'DeepLink Protocol Innovative Home Mining Solution',
          link: 'https://medium.com/@DeepLinkGlobal/deeplink-protocol-innovative-home-mining-solution-3d2e9c6d0dca',
          data: 'Feb 7, 2024',
          subjection: 'medium',
          img: media_img1
        }
      ])
      const linkhref = (val) => {
        window.open(val)
      }
      return {
        lan,
        linkhref,
        reportData
      };
    }
  })
</script>

<style scoped lang="scss">
.report {
  width: 1200px;
  margin: 0 auto 60px;
  box-sizing: border-box;
  .show {
    display: block;
  }
  .hide {
    display: none;
  }
  .report_title {
    color: #fff;
    font-size: 26px;
    font-weight: 600;
    line-height: 34px;
    text-align: center;
    margin-bottom: 30px;
    letter-spacing: 0.05em;
  }
  .report_cont {
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    .report_li {
      width: 388px;
      display: flex;
      cursor: pointer;
      overflow: hidden;
      margin-right: 18px;
      border-radius: 24px;
      align-items: center;
      margin-bottom: 12px;
      background: rgba(152, 255, 194, 0.12);
      &:nth-child(3n) {
        margin-right: 0;
      }
      .li_img {
        width: 120px;
        height: 140px;
        object-fit: cover;
      }
      .li_content {
        flex: 1;
        height: 140px;
        display: flex;
        padding: 10px;
        box-sizing: border-box;
        flex-direction: column;
        justify-content: space-between;
        .title {
          width: 100%;
          height: 66px;
          color: #fff;
          font-size: 14px;
          font-weight: 400;
          line-height: 22px;
          letter-spacing: 0em;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 3;
          -webkit-box-orient: vertical;
        }
        .text1 {
          color: rgba(255, 255, 255, 0.6);
          font-size: 12px;
          font-weight: 400;
          line-height: 16px;
          letter-spacing: 0em;
        }
        .text2 {
          display: flex;
          font-size: 12px;
          font-weight: 400;
          line-height: 16px;
          letter-spacing: 0em;
          align-items: center;
          justify-content: space-between;
          color: rgba(255, 255, 255, 0.6);
          .text2_2 {
            display: flex;
            align-items: center;
            font-size: 12px;
            font-weight: 400;
            line-height: 16px;
            letter-spacing: 0em;
            .icon {
              width: 14px;
              height: 14px;
              margin-right: 4px;
              display: inline-block;
            }
          }
        }
      }
    }
  }
}

@media screen and (max-width: 1200px) {
  .report {
    width: 90%;
    .show {
      display: none;
    }
    .hide {
      display: block;
    }
    .report_cont {
      .report_li {
        width: 100%;
        margin-right: 0;
        .li_img {
          width: 150px;
        }
      }
      
    }
  }
}
</style>